import { createSelector } from '@reduxjs/toolkit';

import { PIK_PLUS_NUMBER_OF_COMPLEXES_PER_PAGE } from '../../settings/residentialComplexes';
import { type IResidentialComplex } from '../../types/residentials';

import { getFilteredResidentialComplexes } from './getFilteredResidentialComplexes';

export const getAllocatedResidentialComplexes = createSelector(
  getFilteredResidentialComplexes,
  (items): IResidentialComplex[] => {
    const defaultItems = Array.of<IResidentialComplex>();
    const plusItems = Array.of<IResidentialComplex>();

    for (const item of items) {
      if (item && item.displayType === 'plus') {
        plusItems.push(item);
      } else {
        defaultItems.push(item);
      }
    }

    const shuffledItems = Array.of<IResidentialComplex>();

    let count = 0;

    for (let i = 0; i < defaultItems.length; i++) {
      if (count === PIK_PLUS_NUMBER_OF_COMPLEXES_PER_PAGE - 1) {
        const item = plusItems.shift();
        if (item) {
          shuffledItems.push(item);
        }
        count = 0;
      }

      shuffledItems.push(defaultItems[i]);
      count++;
    }

    if (plusItems.length) {
      shuffledItems.push(...plusItems);
    }

    return shuffledItems;
  },
);
